import { OrderDetail } from "./interface";
import http from "./request";

// 获取会员信息
export function getMemberInfo(params: any) {
  return http.request({
    url: "/member/getMemberInfo",
    method: "post",
    params,
  });
}

// 获取CRM会员信息
export function getMemberInfoByOpenId(params: any) {
  return http.request({
    url: "/member/getMemberInfoByOpenId",
    method: "post",
    params,
  });
}

// 兑换记录
export function exchangeOrderList(params: any) {
  return http.request({
    url: "/member/getMemberOrders",
    method: "post",
    data: params,
  });
}

// 积分明细
export function pointsDetailsList(params: any) {
  return http.request({
    url: "/member/getMemberPoints",
    method: "post",
    data: params,
  });
}

// 校验库存
export function verifyStock(params: any) {
  return http.request({
    url: "/product/verifyProduct",
    method: "post",
    data: params,
  });
}

// 创建积分订单
export function createOrder(params: any) {
  return http.request({
    url: "/member/createOrder",
    method: "post",
    data: params,
  });
}

// 兑换礼品
export function createPointOrder(params: any) {
  return http.request({
    url: "/member/createPointOrder",
    method: "post",
    params,
  });
}

// 编辑地址
export function editCustomerAddress(data: any) {
  return http.request({
    url: "/address/editCustomerAddress",
    method: "post",
    data,
  });
}

// 获取地址信息
export function getAddressTree() {
  return http.request({
    url: "/address/getAddressTree",
    method: "post",
  });
}

// 获取用户地址
export function getCustomerAddress(data: any) {
  return http.request({
    url: "/address/getCustomerAddress",
    method: "post",
    data,
  });
}

// 保存用户地址
export function saveCustomerAddress(data: any) {
  return http.request({
    url: "/address/saveCustomerAddress",
    method: "post",
    data,
  });
}

// 兑换商品列表
export function getProductList(params: any) {
  return http.request({
    url: "/product/getProductList",
    method: "post",
    params,
  });
}

// 兑换商品详情
export function getProductDetails(params: any) {
  return http.request({
    url: "/product/getProductInfo",
    method: "post",
    data: params,
  });
}

export function getOrderDetail(data: {
  orderId: string;
}): Promise<{ data: OrderDetail }> {
  return http.request({
    url: "/member/getMemberOrderDetail",
    method: "post",
    data,
  }) as unknown as Promise<{ data: OrderDetail }>;
}
